import { AlleGrunntyperMedDefault } from "../valideringstyper/grunntyper";

const default_validering: AlleGrunntyperMedDefault = {
  ikke: {
    null: "Må fyllast ut",
    blank: "Kan ikkje bestå av berre blanke teikn",
    tom: "Kan ikkje vere tomt",
    lik: {
      verdi: "Kan ikkje vere lik {{messageParams.value}}",
    },
  },
  stoerre: {
    enn: "Må vere større enn {{messageParams.value}}",
    eller: {
      lik: "Må vere større eller lik {{messageParams.value}}",
    },
  },
  mindre: {
    eller: {
      lik: "Må vere mindre eller lik {{messageParams.value}}",
    },
  },
  mellom: "Må vere mellom {{messageParams.min}} og {{messageParams.max}}",
  lik: "Må vere lik {{messageParams.value}}",
  min: {
    lengde: "Må vere minst {{messageParams.minLength}}",
  },
  maks: {
    lengde: "Kan ikkje vere lengre enn {{messageParams.maxLength}}",
    size: "Kan ikkje vere større enn {{messageParams.maxSize}}",
  },
  true: "Noko er feil",
  ugyldig: {
    moenster: "Ikkje gyldig format",
  },
  en: {
    av: "Må vere ein av {{messageParams, generic_string_list_formatter}}",
  },
  filstoerrelse: {
    totalt:
      "Total filstorleik må vere mindre enn {{messageParams.maksFilstoerrelseString}}",
  },
};
export default default_validering;
